import { axios as $http } from 'cm'
import './index.scss'

function getRunTime(str) {
  let result
  let _href = window.location.href.split('.')[0]

  _href.replace(/-(qc\d?|box\d?)/, (s, v) => {
    result = str.replace(/\./, `-${v}.`)
  })

  if (!result) {
    result = str
  }

  return result
}
// 判断环境
let M_HOST = getRunTime('//m.xinli001.com')
let STATIC_HOST = getRunTime('//static.xinli001.com')

// 判断是否APP环境
const IS_APP = window.$platform.isYixinliApp

const APIS = {
  mHost: M_HOST,
  staticHost: STATIC_HOST,
  like: `${M_HOST}/lesson/comment/zan`,
  login: `${M_HOST}/account/login`,
  getComment: `${M_HOST}/lesson/rate-list`
}

/**
 * 列表模板
 * @param {*} data
 */
const tpl = data => `
  <li class="comment-item">
      <div class="avatar-wrap">
          <div class="commenter-avatar"
              style="background-image:url(${data.userAvatar})"></div>
      </div>
      <div class="comment-infos">
          <div class="commenter-wrap">
              <div class="commenter-name">
                ${data.userNickname}
              </div>
              <!-- 已经赞 加类名liked -->
              <div onclick="like(this)" class="like-action ${
                +data.isZan === 1 ? 'liked' : ''
              }"  data-comment-id="${data.id}">
                  <div class="like-num">${data.zanNum}</div>
                  <div class="like-icon"></div>
              </div>
          </div>
          <p class="comment-text">${data.content}</p>
          <p class="comment-time">${data.created}</p>
          ${data.collegeRateReplyVos
            .map(
              item => `
              <div class="comment-reply">
                <p class="comment-reply-name">${item.replyNickname}&nbsp&nbsp回复：</p>
                <p class="comment-text">${item.content}</p>
                <p class="comment-time">${item.created}</p>
            </div>
            `
            )
            .join('')}
      </div>
  </li>
`

export default (isLogin, getListContent, fetchParams = {}) => {
  console.log(isLogin)
  // 判断是否登录
  function checkoutLogin() {
    if (!isLogin) {
      window.toast('请先注册登录，页面即将跳转...', 3000)
      setTimeout(() => {
        let _href = IS_APP
          ? 'yixinli://open_user_login'
          : `${APIS.login}?next=${encodeURIComponent(window.location.href)}`
        window.location.href = _href
      }, 3000)

      return false
    } else {
      return true
    }
  }

  // 加载更多评价
  async function commentLoadMore(
    loadMoreBtn = document.querySelectorAll('.comment-list-loading-tip')
  ) {
    // if (loadMoreBtn.innerHTML.replace(/(^\s+)|(\s+$)/g, '') === '已全部展示') {
    //   commentLoadMore.ifFinish = true
    //   return
    // }
    if (commentLoadMore.ifFinish || commentLoadMore.loading) {
      return
    }

    // 埋点
    // window.yxl.stat.send({
    //   name: '课程-详情页-评价「加载更多」点击',
    //   properties: {}
    // })

    commentLoadMore.loading = true
    // loadMoreBtn.innerHTML = '加载中'
    for (let i = 0; i < loadMoreBtn.length; i++) {
      loadMoreBtn[i].innerHTML = '加载中'
    }

    let page = commentLoadMore.page || 1
    let pageSize = 10
    // if (page === 1) {
    //   pageSize = 5
    // }
    try {
      let { data } = await $http(`${APIS.getComment}`, {
        params: Object.assign(
          {
            lesson_id: window.baseInfo.lesson_id,
            page,
            size: pageSize
          },
          fetchParams
        )
      })
      // let data = {
      //   "code":0,"data":[]
      // }
      let tips = ''

      if (data.code === 0) {
        let comments = data.data
        if (comments.length <= 0) {
          if (page === 1) {
            tips = `<div class="not-comment"></div>`
          } else {
            commentLoadMore.ifFinish = true
            tips = '<div class="finish"></div>'
          }
        } else {
          let commentsElement = ''

          comments.forEach(item => {
            commentsElement += tpl(item)
          })

          if (typeof getListContent === 'function') {
            getListContent(page).innerHTML += commentsElement
          } else {
            document.querySelector('.comment-list').innerHTML += commentsElement
          }

          tips = '上拉加载更多'

          if (comments.length < pageSize) {
            commentLoadMore.ifFinish = true
            tips = '<div class="finish"></div>'
          }
        }

        page += 1
        commentLoadMore.page = page
      } else {
        window.toast(`加载失败，错误代码：${data.code}`, 3000)
      }
      // loadMoreBtn.forEach(v => {
      //   v.innerHTML = tips
      // })

      for (let i = 0; i < loadMoreBtn.length; i++) {
        loadMoreBtn[i].innerHTML = tips
      }
      commentLoadMore.loading = false
    } catch (e) {
      console.log(e)
    }

    // loadMoreBtn.innerHTML = tips
  }

  /**
   * 点赞函数
   * @param el
   * @returns {Promise.<void>}
   */
  async function like(el) {
    console.log('like')
    if (!checkoutLogin()) {
      return
    }

    // // 埋点
    // window.yxl.stat.send({
    //   name: '课程-详情页-评价「点赞」点击',
    //   properties: {
    //     '课程参加情况': +window.baseInfo.is_join === 1 ? '已参加课程' : '未参加课程'
    //   }
    // })

    let rateId = el.getAttribute('data-comment-id')
    let numDiv = el.querySelector('.like-num')

    let { data } = await $http.get(`${APIS.like}?rate_id=${rateId}`)

    if (+data.code === 0) {
      let tips = ''
      let newNum = +numDiv.innerHTML

      if (+data.data.is_zan === 0) {
        tips = '取消点赞成功'
        newNum -= 1
        if (newNum <= 0) {
          newNum = 0
        }

        el.classList.remove('liked')
      } else {
        tips = '点赞成功'
        newNum += 1

        el.classList.add('liked')
      }

      window.toast(tips, 3000)
      numDiv.innerHTML = newNum
    } else if (+data.code === 40002) {
      window.toast(data.message, 3000)
    } else {
      window.toast(`点赞失败`, 3000)
      // window.toast(`点赞失败,错误代码：${data.code}`, 3000)
    }
  }
  window.like = like

  const initEvents = () => {
    // 点赞功能
    const COMMENT_ROOT = document

    COMMENT_ROOT &&
      COMMENT_ROOT.addEventListener('click', e => {
        let el = e.target

        while (el !== COMMENT_ROOT) {
          // 点赞
          if (el.classList.contains('like-action')) {
            // console.log(el.classList)
            // like(el)
            break
          } else if (el.classList.contains('loading-tip')) {
            // commentLoadMore(el)
            break
          } else {
            el = el.parentNode
          }
        }
      })
  }

  const bindScroll = () => {
    window.addEventListener('scroll', e => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const bodyH = document.body.scrollHeight
      const winH = window.screen.availHeight
      const commentListDom = document.querySelector('.comment-list')
      const isShow = Boolean(commentListDom) && commentListDom.offsetHeight > 0
      if (bodyH - scrollTop - winH <= 0 && isShow) {
        commentLoadMore()
      }
    })
  }

  return {
    commentLoadMore,
    initEvents,
    bindScroll
  }
}



// WEBPACK FOOTER //
// ./src/page-resource/lesson/compoents/comment/index.js